import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { IImageFile } from 'interfaces/files';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.MANAGEMENT_AND_ORGANIZATION}.${BUSINESS_TOOL_SUB_SECTIONS.MANAGEMENT_AND_ORGANIZATION.MANAGEMENT_TEAM}` as const;

export const INSTITUTION_NAMES = {
  NAME: 'name',
  SPECIALIZATION: 'specialization'
} as const;
  
export interface IInstitution {
  [INSTITUTION_NAMES.NAME]: string;
  [INSTITUTION_NAMES.SPECIALIZATION]: string;
}
  
export const institutionValues = {
  [INSTITUTION_NAMES.NAME]: '',
  [INSTITUTION_NAMES.SPECIALIZATION]: '',
}

export const WORK_EXPERIENCE_NAMES = {
  EMPLOYER: 'Employer',
  POSITION: 'position',
  FROM: 'from',
  TO: 'to',
  FUNCTIONS: 'functions',
} as const;
  
export interface IWorkExperience {
  [WORK_EXPERIENCE_NAMES.EMPLOYER]: string;
  [WORK_EXPERIENCE_NAMES.POSITION]: string;
  [WORK_EXPERIENCE_NAMES.FROM]: string;
  [WORK_EXPERIENCE_NAMES.TO]: string;
  [WORK_EXPERIENCE_NAMES.FUNCTIONS]: string;
}
  
export const workExperienceValues = {
  [WORK_EXPERIENCE_NAMES.EMPLOYER]: '',
  [WORK_EXPERIENCE_NAMES.POSITION]: '',
  [WORK_EXPERIENCE_NAMES.FROM]: '',
  [WORK_EXPERIENCE_NAMES.TO]: '',
  [WORK_EXPERIENCE_NAMES.FUNCTIONS]: '',
}

export const PERSONNEL_PROFILES_NAMES = {
  FILE: 'file',
  NAME: 'name',
  SURNAME: 'surname',
  DATE_OF_BIRTH: 'dateOfBirth',
  POSITION: 'position',
  LIST_OF_INSTITUTIONS: 'listOfInstitutions',
  WORK_EXPERIENCE: 'workExperience',
  KEY_SKILLS: 'keySkills',
  ACHIEVEMENTS: 'achievements',
} as const;

export interface IPersonnelProfiles {
  [PERSONNEL_PROFILES_NAMES.FILE]: IImageFile[];
  [PERSONNEL_PROFILES_NAMES.NAME]: string;
  [PERSONNEL_PROFILES_NAMES.SURNAME]: string;
  [PERSONNEL_PROFILES_NAMES.DATE_OF_BIRTH]: string;
  [PERSONNEL_PROFILES_NAMES.POSITION]: string;
  [PERSONNEL_PROFILES_NAMES.LIST_OF_INSTITUTIONS]: IInstitution[];
  [PERSONNEL_PROFILES_NAMES.WORK_EXPERIENCE]: IWorkExperience[];
  [PERSONNEL_PROFILES_NAMES.KEY_SKILLS]: string;
  [PERSONNEL_PROFILES_NAMES.ACHIEVEMENTS]: string;
}

export const personnelProfilesValue = {
  [PERSONNEL_PROFILES_NAMES.FILE]: [],
  [PERSONNEL_PROFILES_NAMES.NAME]: '',
  [PERSONNEL_PROFILES_NAMES.SURNAME]: '',
  [PERSONNEL_PROFILES_NAMES.DATE_OF_BIRTH]: '',
  [PERSONNEL_PROFILES_NAMES.POSITION]: '',
  [PERSONNEL_PROFILES_NAMES.LIST_OF_INSTITUTIONS]: [institutionValues],
  [PERSONNEL_PROFILES_NAMES.WORK_EXPERIENCE]: [workExperienceValues],
  [PERSONNEL_PROFILES_NAMES.KEY_SKILLS]: '',
  [PERSONNEL_PROFILES_NAMES.ACHIEVEMENTS]: '',
};

export const MANAGEMENT_TEAM_NAMES = {
  HISTORY: 'history',
  SKILLS: 'skills',
  PERSONAL_QUALITIES: 'personalQualities',
  PERSONNEL_PROFILES: 'personnelProfiles',
  WORK_EXPERIENCE: 'workExperience',
} as const;

export interface IManagementAndOrganization{
  [MANAGEMENT_TEAM_NAMES.HISTORY]: string;
  [MANAGEMENT_TEAM_NAMES.SKILLS]: string;
  [MANAGEMENT_TEAM_NAMES.PERSONAL_QUALITIES]: string;
  [MANAGEMENT_TEAM_NAMES.PERSONNEL_PROFILES]: IPersonnelProfiles[];
}

export const managementAndOrganizationInitialValues: IManagementAndOrganization = {
  [MANAGEMENT_TEAM_NAMES.HISTORY]: '',
  [MANAGEMENT_TEAM_NAMES.SKILLS]: '',
  [MANAGEMENT_TEAM_NAMES.PERSONAL_QUALITIES]: '',
  [MANAGEMENT_TEAM_NAMES.PERSONNEL_PROFILES]: [personnelProfilesValue],
};